import { render, staticRenderFns } from "./select-recommend-user.vue?vue&type=template&id=30b805f1&scoped=true&"
import script from "./select-recommend-user.vue?vue&type=script&lang=js&"
export * from "./select-recommend-user.vue?vue&type=script&lang=js&"
import style0 from "./select-recommend-user.vue?vue&type=style&index=0&id=30b805f1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b805f1",
  null
  
)

export default component.exports